<template>
  <v-dialog
    :value="value"
    @input="$emit('input', false)"
    :width="width"
    :persistent="persistent"
    overlay-color="var(--v-background-html-base)"
    overlay-opacity="0.66"
    content-class="dialog"
    no-click-animation
  >
    <slot name="header" v-if="content.title || title">
      <div class="dialog__header">
        <span>{{ content.title || title }}</span>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="!content.isConfirmation"
              icon
              @click="$emit('input', false)"
              v-bind="attrs"
              v-on="on"
              class="action-icon"
            >
              <v-icon color="content-medium">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>{{ Lang.close }}</span>
        </v-tooltip>
      </div>
    </slot>
    <slot v-if="hasDefaultSlot || content.message">
      <div class="dialog__message">{{ content.message }}</div>
    </slot>
    <div class="dialog__footer" v-if="hasFooterSlot && !content.isConfirmation">
      <slot name="footer" />
    </div>

    <slot v-if="content.isConfirmation" name="footer">
      <div class="dialog__confirmation-buttons">
        <ButtonSecondary :width="'auto'" @click="$emit('confirm', false)" :tooltip="content.cancel">{{
          content.cancel
        }}</ButtonSecondary>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :class="['confirm', { danger: content.danger }]"
              @click="$emit('confirm', true)"
              v-bind="attrs"
              v-on="on"
              depressed
              class="action-icon"
            >
              {{ content.confirm }}
            </v-btn>
          </template>
          <span>{{ content.confirm }}</span>
        </v-tooltip>
      </div>
    </slot>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";

import ButtonSecondary from "@/components/customComponents/ButtonSecondary.vue";
import Lang from "@/lang";

const DEFAULT_WIDTH_DIALOG = "496";

export default Vue.extend({
  name: "BasePopup",
  components: {
    ButtonSecondary,
  },

  props: {
    value: Boolean,
    content: {
      type: Object,
      default() {
        return {};
      },
    },
    title: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: DEFAULT_WIDTH_DIALOG,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      Lang,
    };
  },

  computed: {
    hasFooterSlot(): boolean {
      return !!this.$slots.footer;
    },

    hasDefaultSlot(): boolean {
      return !!this.$slots.default;
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/scss/theme.scss";
@import "@/scss/custom_variables.scss";

.dialog {
  &__header {
    display: grid;
    grid-template-columns: auto 36px;
    align-items: center;
    padding-bottom: $space-medium;
    font-weight: 600;
    font-size: 20px;
    border-bottom: 1px solid var(--v-divider-dark-base);
  }

  &__message {
    padding: $space-medium 0;
    font-size: 16px;
    color: var(--v-content-medium-base);
    border-bottom: 1px solid var(--v-divider-dark-base);
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    padding-top: $space-medium;
    margin-top: $space-medium;
    border-top: 1px solid var(--v-divider-dark-base);
  }

  &__confirmation-buttons {
    display: flex;
    justify-content: right;
    column-gap: 8px;
    margin-top: $space-medium;

    .confirm {
      color: var(--v-content-white-base);
      height: $btn-height !important;
      font-size: 16px;
      font-weight: 600;
      overflow: hidden;
      border-radius: $border-radius-small;
      background-color: var(--var-positive-base) !important;

      &.danger {
        background-color: var(--var-error-base) !important;
      }
    }
  }
}

::v-deep {
  .dialog {
    padding: $space-normal;
    border-radius: $border-radius-x-small;
    background-color: var(--v-primary-base);
    box-shadow: $box-shadow-light;
  }
}
</style>
